import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { PangeaDeleteModal } from "@pangeacyber/react-mui-shared";
import { Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useStoreFileViewerContext } from "../../hooks/context";
import { alertOnError } from "../AlertSnackbar/hooks";
var BulkDeleteFilesButton = function (_a) {
    var selected = _a.selected, ButtonProps = _a.ButtonProps, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, _c = _a.view, view = _c === void 0 ? "text" : _c;
    var _d = useStoreFileViewerContext(), apiRef = _d.apiRef, reload = _d.reload;
    return (_jsx(PangeaDeleteModal, { description: "Are you sure you wish to delete the ".concat(selected.length, " selected along with all versions which will be permanently removed?"), title: "Delete ".concat(selected.length, " selected"), onDelete: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!apiRef.delete)
                    return [2 /*return*/];
                return [2 /*return*/, Promise.all([
                        selected.map(function (id) {
                            return !!apiRef.delete &&
                                apiRef.delete({ id: id, force: true }).catch(function (err) {
                                    alertOnError(err);
                                });
                        }),
                    ])
                        .then(function () { })
                        .finally(function () {
                        onClose();
                        reload();
                        setTimeout(function () {
                            // Add a delayed reload as the first reloading may still return items that were just deleted..
                            reload();
                        }, 1500);
                    })];
            });
        }); }, Button: function (props) {
            return view === "icon" ? (_jsx(IconButton, { onClick: props.onClick, children: _jsx(DeleteIcon, { fontSize: "small", color: "error" }) })) : (_jsx(Button, __assign({ sx: { width: "100%" }, color: "error", variant: "text", startIcon: _jsx(DeleteIcon, { fontSize: "small" }), onClick: props.onClick }, ButtonProps, { children: "Delete" })));
        } }));
};
export default BulkDeleteFilesButton;
